<template>
    <ul class="nav nav-tabs header-tabs nav-overflow" :key="customerId">
        <li class="nav-item">
            <router-link
                :to="{name:'people.customer.general'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('General')}}</router-link>
        </li>
        <li class="nav-item" v-if="$loadModule('appointment')">
            <router-link
                :to="{name:'people.customer.appointments'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Appointments')}}</router-link>
        </li>
        <!-- <li class="nav-item">
            <router-link
                :to="{name:'people.customer.services'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Exams')}}</router-link>
        </li>-->
        <li class="nav-item" v-if="$loadModule('treatments') || $loadModule('textTreatments')">
            <router-link
                :to="{name:'people.customer.treatment'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Treatment')}}</router-link>
        </li>
        <li class="nav-item" v-if="$loadModule('treatments')">
            <router-link
                :to="{name:'people.customer.t-plan'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Treatment plan')}}</router-link>
        </li>
        <!-- <li class="nav-item">
            <router-link
                :to="{name:'people.customer.timeline'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Timeline')}}</router-link>
        </li>-->

        <li class="nav-item" v-if="$loadModule('notes')">
            <router-link
                :to="{name:'people.customer.notes'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Notes')}}</router-link>
        </li>
        <li class="nav-item" v-if="$loadModule('xrays')">
            <router-link
                :to="{name:'people.customer.xrays'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Xrays')}}</router-link>
        </li>
        <li class="nav-item" v-if="$loadModule('storage')">
            <router-link
                :to="{name:'people.customer.storage'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Storage')}}</router-link>
        </li>
        <li class="nav-item" v-if="$loadModule('billing')">
            <router-link
                :to="{name:'people.customer.transactions'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Billing')}}</router-link>
        </li>
        <li class="nav-item">
            <router-link
                :to="{name:'people.customer.communications'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Communications')}}</router-link>
        </li>
        <li class="nav-item" v-if="$loadModule('labs')">
            <router-link
                :to="{name:'people.customer.labs'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Labs')}}</router-link>
        </li>
        <li class="nav-item">
            <router-link
                :to="{name:'people.customer.tasks'}"
                exact
                active-class="active"
                class="nav-link pointer text-nowrap"
            >{{$t('Tasks')}}</router-link>
        </li>
    </ul>
</template>

<script>
export default {
    props: ['customerId'],

}
</script>
